import React, {ClipboardEvent, useEffect, useState} from 'react';
import {
    EventUserRegistration,
    EventUserRegistrationWrapper,
    OptionLabelValue,
    Result
} from "../interfaces";
import {checkIfUtmLSExists, regEventUser} from "../DAL/data-service";
import {getIsChina} from "../../../domain/hidden-data-provider";
import {
    createControl,
    removeInvisibleCharsOnPaste,
    updateControl,
    validateControl,
    validateForm
} from "../../../domain/validation/validation";
import {getSimpleCaptchaValidationError} from "../../../domain/captcha/simple-captcha";
import {IFormControl} from "../../../ui/forms/interfaces";
import {
    getRecaptcha2Error,
    getRecaptchaToken,
    renderRecaptcha2,
    resetRecaptcha2
} from "../../../domain/captcha/recaptcha-provider";
import ChinaCaptchaField from "../../../ui/forms/fields/captcha-china-field";
import Recaptcha3Text from "../../../domain/captcha/recaptcha3-terms";
import FormTextField from "../../../ui/forms/fields/text-field";
import {IServerValidation} from "../../../domain/validation/interfaces";
import SelectReactField, {IOption} from "../../../ui/forms/fields/select-react-field";
import {getPageNodeGUID} from "../../../domain/common";
import {sendGAEvent} from "../../../domain/marketing/gtm-provider";

interface IEventsContactProps {
    dataUser: EventUserRegistration,
    subEventsList: OptionLabelValue[],
    eventType: string,
    eventID: number
}

/**
 * the entry point
 */
const EventsSignUpApp= (props: IEventsContactProps) => {
    const isChina = getIsChina();
    const isSubEvent:boolean = props.eventType === 'multi';
    const isExtraRSVPFields = props.dataUser.isExtraRSVPFields;
    const upgradeOptions: IOption[] = [
        {label: 'Select ...', value: ''},
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'},
        {label: 'Maybe', value: 'maybe'}
    ];

    // validation ---------------------------------------
    const emailControl = createControl('email', props.dataUser.email, {
        required: true,
        email: true
    });
    const firstNameControl = createControl('firstName', props.dataUser.firstName, {
        required: true
    });
    const lastNameControl = createControl('lastName', props.dataUser.lastName, {
        required: true
    });
    const phoneControl = createControl('phone', props.dataUser.phone || '', {
    });
    const organizationControl = createControl('organization', props.dataUser.organization || '', {
        required: true
    });
    const positionControl = createControl('position', props.dataUser.position || '', {
        required: true
    });
    const consoleBrandControl = createControl('consoleBrand', props.dataUser.consoleBrand || '', {
        required: true
    });
    const upgradeControl = createControl(
        'upgrade',
        upgradeOptions.find(option => option.value === (props.dataUser.upgrade || '')) || upgradeOptions[0],
        {
            required: (currentControl) => {
                if(!currentControl) return false;

                const current = currentControl.value;
                if(!current) return false;

                return current.value !== '';
            }
        }
    );

    const subEventControl = createControl('ddlSubEvent', props.subEventsList[0], {
        required: (currentControl) => {
            if(!currentControl) return false;

            const current = currentControl.value;
            if(!current) return false;

            return current.value !== 0;
        }
    });

    const simpleCaptchaControl = createControl('simpleCaptcha', '', {
        required: true,
        requiredMessage: getSimpleCaptchaValidationError(),
        length: 5,
    });
    const [isValid,setIsValid] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [response, setResponse] = useState<IServerValidation|null>();
    const [ResultData, setResultData] = useState<Result>();

    const [email, setEmail] = useState<IFormControl>(emailControl);
    const [firstName, setFirstName] = useState<IFormControl>(firstNameControl);
    const [lastName, setLastName] = useState<IFormControl>(lastNameControl);
    const [phone, setPhone] = useState<IFormControl>(phoneControl);
    const [organization, setOrganization] = useState<IFormControl>(organizationControl);
    const [position, setPosition] = useState<IFormControl>(positionControl);
    const [consoleBrand, setConsoleBrand] = useState<IFormControl>(consoleBrandControl);
    const [upgrade, setUpgrade] = useState<IFormControl>(upgradeControl);
    const [subEvent, setSububEvent] = useState<IFormControl>(subEventControl);

    // simple captcha - used for china
    const [simpleCaptchaCode, setSimpleCaptchaCode] = useState<IFormControl>(simpleCaptchaControl);
    const [simpleCaptchaAttempts, setSimpleCaptchaAttempts] = useState(0);

    // google recaptcha version 2 & 3
    const [recaptchaVersion, setRecaptchaVersion] = useState(3);
    const [recaptcha2WidgetID, setRecaptcha2WidgetID] = useState(0);

    // captcha: common
    const [captchaError, setCaptchaError] = useState('');

    /**
     * load initial data (drop-downs content) on page load once
     */
    useEffect(() => {
        (async () => {
            setIsLoading(false);
        })();
    }, []);

    /**
     * handle save changes
     */
    const regUser = async () => {

        const captchaToken = !isChina ? await getRecaptchaToken(recaptchaVersion) : simpleCaptchaCode.value;

        if(!captchaToken){
            setCaptchaError(isChina ? getSimpleCaptchaValidationError() : getRecaptcha2Error());
            setIsLoading(false);
            return;
        }

        var validateArray:any = [[firstName, setFirstName],[lastName, setLastName],[email, setEmail]];
        if(isChina){
            validateArray.push([simpleCaptchaCode, setSimpleCaptchaCode]);
        }
        if(isSubEvent){
            validateArray.push([subEvent, setSububEvent]);
        }
        if(isExtraRSVPFields){
            validateArray.push([phone, setPhone]);
            validateArray.push([organization, setOrganization]);
            validateArray.push([position, setPosition]);
            validateArray.push([consoleBrand, setConsoleBrand]);
            validateArray.push([upgrade, setUpgrade]);
        }

        // client side validation
        /*const isValidate =
            isChina ?
                validateForm([
                    [firstName, setFirstName],
                    [lastName, setLastName],
                    [email, setEmail],
                    [subEvent, setSububEvent],
                    [simpleCaptchaCode, setSimpleCaptchaCode],
                ]) :
                validateForm([
                    [firstName, setFirstName],
                    [lastName, setLastName],
                    [email, setEmail],
                    [subEvent, setSububEvent],
                ]);*/
        const isValidate =validateForm(validateArray);
        setIsValid(isValidate);
        if(!isValidate) return;


        const userReg: EventUserRegistration = {
            firstName : firstName.value,
            lastName : lastName.value,
            email : email.value,
            phone: isExtraRSVPFields ? phone.value : '',
            organization: isExtraRSVPFields ? organization.value : '',
            position: isExtraRSVPFields ? position.value : '',
            consoleBrand: isExtraRSVPFields ? consoleBrand.value : '',
            upgrade: isExtraRSVPFields ? upgrade?.value?.value : '',
            subEventID: subEvent?.value?.value,
            captchaCode: captchaToken,
            recaptchaVersion: recaptchaVersion,
            rSVP_GUID: '',
            eventID: props.eventID,
            userID: 0,
            message: '',
            pageNodeGUID: getPageNodeGUID(),
            isExtraRSVPFields: isExtraRSVPFields
        };

        var eventUserRegWrapper:EventUserRegistrationWrapper = {utmLs: checkIfUtmLSExists(), userData:userReg, isSubEvent: isSubEvent};


        const response = await regEventUser(eventUserRegWrapper);

        sendGAEvent('Event Signup', 'Signup');

        if(!response || response.statusCode !== 200) {
            //setError(response.data as unknown as ModelServerErrors);
            return;
        }

        //------------------------------------------------------------------------recaptcha-error
        if(isChina){

            // re-render simple captcha
            setSimpleCaptchaAttempts(simpleCaptchaAttempts + 1);
        }
        else{
            if(response?.data.resultObjectType === 'recaptcha-error') {
                setRecaptchaVersion(2);
                renderCaptcha2Fallback();
            }

            if(recaptchaVersion === 2){
                resetRecaptcha2();
            }
        }
        //------------------------------------------------------------------------REDIRECT if success
        if(response.data.resultObjectType === "REDIRECT")
            window.location.href = response.data.resultObjectEx.toString();

        if(response.data.resultObjectType === "REFRESH") {
            window.location.reload();
            return;
        }

        //------------------------------------------------------------------------Error message
        if(!response.data.resultStatus && response.data.message !== '')
            setResultData(response.data);
        //console.log('response.data: ',response.data);
    };
    /**
     * if recaptcha 3 returns low score (the limit is defined in kentico settings),
     * then recaptcha 2 fallback should be rendered inside <div id="recaptcha"></div>
     */
    const renderCaptcha2Fallback = () => {
        if(!window.grecaptcha) return;

        window.grecaptcha.ready(async () => {
            const widgetID = await renderRecaptcha2('recaptcha');
            setRecaptcha2WidgetID(widgetID);
        });
    };

    /**
     * empty errors on click
     */
    const handleFieldClick = () =>{
        setResponse(null);
        setCaptchaError('');
    };

    return (
        <div className="my-4">

            {
                !isLoading  &&
                <>

                    {/*<div className="mb-4">: isValid:{isValid?.toString()}</div>*/}
                    {props.eventType === 'multi' &&

                        <SelectReactField
                            onChange={
                                (option) => {
                                    //console.log(option);
                                    const updatedControl = updateControl(subEvent, option, true);
                                    console.log('updatedControl', updatedControl)
                                    setSububEvent(updatedControl);
                                    setResponse(null); // empty server error
                                    setCaptchaError('');
                                }
                            }
                            onBlur={ (option) => {
                                //setSububEvent(updateControl(subEvent, option, !subEvent.isValid));
                            }}
                            label={"Sub Event"}
                            options={props.subEventsList}
                            selectIdControl={subEvent}
                            idPrefix={"ddlSubEvent"}
                        />
                    }

                    <FormTextField
                        id={ 'first-name-tb' }
                        label={ 'First Name' }
                        control={ firstName }
                        maxLength={ 100 }
                        onChange={ evt => {
                            const $target = evt.target as HTMLInputElement;
                            setFirstName(updateControl(firstName, $target.value, !firstName.isValid));
                            setResponse(null); // empty server error
                            setCaptchaError('');
                        }}
                        onBlur={ evt => {
                            setFirstName(validateControl(firstName));
                        }}
                        onClick={ handleFieldClick }
                        /*onKeyUp={ handleEnter }*/
                        onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                            setFirstName(updateControl(firstName, removeInvisibleCharsOnPaste(evt)));
                        }}
                    />

                    <FormTextField
                        id={ 'last-name-tb' }
                        label={ 'Last Name' }
                        control={ lastName }
                        maxLength={ 100 }
                        onChange={ evt => {
                            const $target = evt.target as HTMLInputElement;
                            setLastName(updateControl(lastName, $target.value, !lastName.isValid));
                            setResponse(null); // empty server error
                            setCaptchaError('');
                        }}
                        onBlur={ evt => {
                            setLastName(validateControl(lastName));
                        }}
                        onClick={ handleFieldClick }
                        /*onKeyUp={ handleEnter }*/
                        onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                            setLastName(updateControl(lastName, removeInvisibleCharsOnPaste(evt)));
                        }}
                    />
                    <FormTextField
                        id={ 'email-tb' }
                        label={ 'Email' }
                        control={ email }
                        maxLength={ 80 }
                        onChange={ evt => {
                            const $target = evt.target as HTMLInputElement;
                            setEmail(updateControl(email, $target.value, !email.isValid));
                            setResponse(null); // empty server error
                            setCaptchaError('');
                        }}
                        onBlur={ evt => {
                            setEmail(validateControl(email));
                        }}
                        onClick={ handleFieldClick }
                        /*onKeyUp={ handleEnter }*/
                        onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                            setEmail(updateControl(email, removeInvisibleCharsOnPaste(evt)));
                        }}
                    />
                    {
                        isExtraRSVPFields &&
                        <>
                            <FormTextField
                                id={ 'phone-tb' }
                                label={ 'Phone' }
                                control={ phone }
                                maxLength={ 100 }
                                onChange={ evt => {
                                    const $target = evt.target as HTMLInputElement;
                                    setPhone(updateControl(phone, $target.value, !phone.isValid));
                                    setResponse(null);
                                    setCaptchaError('');
                                }}
                                onBlur={ evt => {
                                    setPhone(validateControl(phone));
                                }}
                                onClick={ handleFieldClick }
                                onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                                    setPhone(updateControl(phone, removeInvisibleCharsOnPaste(evt)));
                                }}
                            />

                            <FormTextField
                                id={ 'organization-tb' }
                                label={ 'Name of your organization' }
                                control={ organization }
                                maxLength={ 200 }
                                onChange={ evt => {
                                    const $target = evt.target as HTMLInputElement;
                                    setOrganization(updateControl(organization, $target.value, !organization.isValid));
                                    setResponse(null);
                                    setCaptchaError('');
                                }}
                                onBlur={ evt => {
                                    setOrganization(validateControl(organization));
                                }}
                                onClick={ handleFieldClick }
                                onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                                    setOrganization(updateControl(organization, removeInvisibleCharsOnPaste(evt)));
                                }}
                            />

                            <FormTextField
                                id={ 'position-tb' }
                                label={ 'Your current position' }
                                control={ position }
                                maxLength={ 200 }
                                onChange={ evt => {
                                    const $target = evt.target as HTMLInputElement;
                                    setPosition(updateControl(position, $target.value, !position.isValid));
                                    setResponse(null);
                                    setCaptchaError('');
                                }}
                                onBlur={ evt => {
                                    setPosition(validateControl(position));
                                }}
                                onClick={ handleFieldClick }
                                onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                                    setPosition(updateControl(position, removeInvisibleCharsOnPaste(evt)));
                                }}
                            />
                        <div className="pt-6 md:pt-0">
                            <FormTextField
                                id={ 'console-brand-tb' }
                                label={ 'Which brand of audio consoles are you currently using?' }
                                control={ consoleBrand }
                                maxLength={ 200 }
                                onChange={ evt => {
                                    const $target = evt.target as HTMLInputElement;
                                    setConsoleBrand(updateControl(consoleBrand, $target.value, !consoleBrand.isValid));
                                    setResponse(null);
                                    setCaptchaError('');
                                }}
                                onBlur={ evt => {
                                    setConsoleBrand(validateControl(consoleBrand));
                                }}
                                onClick={ handleFieldClick }
                                onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                                    setConsoleBrand(updateControl(consoleBrand, removeInvisibleCharsOnPaste(evt)));
                                }}
                            />
                        </div>
                        <div className ="pt-8 md:pt-0">
                            <SelectReactField
                                onChange={
                                    (option) => {
                                        const updatedControl = updateControl(upgrade, option, true);
                                        setUpgrade(updatedControl);
                                        setResponse(null);
                                        setCaptchaError('');
                                    }
                                }
                                onBlur={ () => {
                                    setUpgrade(currentUpgrade => validateControl(currentUpgrade));
                                }}
                                label={ 'Are you planning to upgrade in the next 6 months' }
                                options={ upgradeOptions }
                                selectIdControl={ upgrade }
                                idPrefix={ 'upgrade' }
                            />
                        </div>
                        </>
                    }
                    {
                        /* ------------- google recaptcha version 2 or 3 ------------- */
                        !isChina &&
                        <div id="recaptcha" className={`mb-4 flex justify-center recaptcha recaptcha-version-${ recaptchaVersion }`}/>
                    }

                    {
                        /* ------------- china simple captcha ------------- */
                        isChina &&
                        <ChinaCaptchaField
                            control={ simpleCaptchaCode }
                            setSimpleCaptchaCode={ setSimpleCaptchaCode }
                            simpleCaptchaAttempts={ simpleCaptchaAttempts }
                        />
                    }
                    {
                        captchaError &&
                        <div className="text-sm text-red my-4 text-center" data-id={ recaptcha2WidgetID }>{ captchaError }</div>
                    }
                    <div>
                        <button type="button" className="w-btn p-4"
                                onClick={evt => {
                                    regUser();
                                }}>Register Now</button>
                    </div>
                    {
                        isValid !== null && !isValid &&
                        <span></span>
                    }
                    {/*
                        isValid !== null && !isValid &&
                        <div className ="mt-4 error-box">
                            Data empty or wrong
                        </div>
                    */}
                    {!ResultData?.resultStatus && ResultData?.message != null && ResultData?.message.toString() !== "" &&

                                <div className="mt-4 error-box" dangerouslySetInnerHTML={{ __html: ResultData?.message?.toString() }} />

                    }
                    {
                        !isChina && recaptchaVersion === 3 &&
                        <div className="mt-4 text-center">
                            <Recaptcha3Text />
                        </div>
                    }
                </>
            }

        </div>
    )
};

export default EventsSignUpApp;